// IMPORTANT: this file was generated using SVGR, please do not edit directly. Refer to the icon README.md for more info.

import type { FC } from 'react';

import { Icon, type IconProps } from './../IconWrapper';
const SvgThumbsDownIcon: FC<IconProps> = ({ color, size, verticalAlign }) => (
  <Icon color={color} size={size} verticalAlign={verticalAlign}>
    <path
      fill="#716A6A"
      d="m10.88 21.94 5.53-5.54c.37-.37.58-.88.58-1.41V5c0-1.1-.9-2-2-2H6c-.8 0-1.52.48-1.83 1.21L.91 11.82C.06 13.8 1.51 16 3.66 16h5.65l-.95 4.58c-.1.5.05 1.01.41 1.37.59.58 1.53.58 2.11-.01M21 3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2"
    />
  </Icon>
);
export default SvgThumbsDownIcon;
SvgThumbsDownIcon.displayName = 'SvgThumbsDownIcon';
